import { useMatches } from "react-router";
import { getLoaderData } from "@helpers/getLoaderData";
import { HttpStatusCode } from "axios";

type AdvertisementOverlayProps = {
  className?: string;
};
/**
 * This component is used to display the advertisement overlay on the page.
 * Suppresses hydration warnings because the overlay will be hidden in the server side
 */
const AdvertisementOverlay = ({
  className,
}: AdvertisementOverlayProps): React.ReactElement => {
  const matches = useMatches();
  const currentMatch = matches[matches.length - 1];
  const loaderData = getLoaderData(currentMatch);

  if (loaderData && loaderData.statusCode !== HttpStatusCode.Ok) return <></>;
  if (typeof loaderData?.payload === "undefined") return <></>;
  if (typeof loaderData?.payload === "string") return <></>;

  const adSettings = loaderData.payload.adSettings;

  if (!adSettings) return <></>;

  return (
    <div
      id="MyPageOverlay"
      suppressHydrationWarning
      className={className} // className="overlayWhite"
    ></div>
  );
};

export default AdvertisementOverlay;
